// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { z } from 'zod';

export const exceptionTypeSchema = z.enum([
  'IN_SERVICE_DATE_BEFORE_INVENTORY',
  'FIRST_SALE_DATE_BEFORE_INVENTORY',
  'DISPOSAL_DATE_BEFORE_INVENTORY',
  'FIRST_ASSIGNMENT_BEFORE_INVENTORY',
  'FIRST_MOVEMENT_BEFORE_INVENTORY',
  'MISSING_COST_BASIS',
  'DEPLOYMENT_WITHOUT_ACQUISITION',
  'SALVAGE_EXCEEDS_50_PERCENT',
  'MISSING_USEFUL_LIFE',
]);

export type ExceptionType = z.infer<typeof exceptionTypeSchema>;
